import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/SolutionSection.css';

const SolutionSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="landing-section" aria-labelledby="solution-heading">
            <div className="landing-container">
                <SectionHeader title={t('solution.title')} id="solution-heading" />
                <div className="solution-section__grid">
                    <article id="couples" className="solution-section__card landing-card">
                        <span className="solution-section__badge">{t('solution.forCouples.title')}</span>
                        <h3 className="solution-section__card-title">{t('solution.forCouples.title')}</h3>
                        <p className="solution-section__card-body">{t('solution.forCouples.body')}</p>
                    </article>
                    <article id="guests" className="solution-section__card landing-card">
                        <span className="solution-section__badge solution-section__badge--guests">
                            {t('solution.forGuests.title')}
                        </span>
                        <h3 className="solution-section__card-title">{t('solution.forGuests.title')}</h3>
                        <p className="solution-section__card-body">{t('solution.forGuests.body')}</p>
                    </article>
                </div>
            </div>
        </section>
    );
};

export default SolutionSection;
